<template>
    <vue-modal :open="open">
        <div class="bax-modal-content bax-modal-icon-content text-center">
            <div class="bax-icon bax-remove d-flex align-items-center justify-content-center">
                <i class="icon-delete"></i>
            </div>
            <h2>Back to Custom Formulations</h2>
            <p>Are you sure? If you have any unsaved changes, these will be lost.</p>
            <div class="bax-modal-action-items">
                <button type="button" class="bax-btn bax-btn-bordered-blue-brand" @click.prevent="closeModal">Cancel</button>
                <button type="button" class="bax-btn bax-btn-blue-brand" :class="{ 'loading': loading }" @click.prevent="onDiscard()">Continue</button>
            </div>
        </div>
    </vue-modal>
</template>
<script>

export default {
    name: 'DiscardModal',
    props: {
        open: {
            required: true,
        },
    },
    data() {
        return {
            loading: false,
        };
    },
    methods: {
        closeModal() {
            this.$emit('modal_discard', false);
        },
        onDiscard() {
            this.loading = true;
            this.$router.push({ name: 'TPNCustomFormulation' });
        },
    },
};
</script>
